import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { User } from '../../dataTypes/user';
import { LanguageService } from '../../services/LanguageService';
import { GuestsService } from '../../services/GuestsService';
import { AuthServiceGuest } from '../../services/AuthServiceGuest';
import { CurrentUser } from '../../dataTypes/CurrentUser';
import { Company } from '../../dataTypes/GuestSubsCompany';
import { MatDialog } from '@angular/material';
import { EditUserDialog } from './editUser/editUser.dialog';
import { MessageToUserDialog } from '../../shared/dialog/messageToUser.dialog';
import { ControllerResponse } from '../../dataTypes/ControllerResponse';
import { NewUserModel } from '../../dataTypes/NewUserModel';

@Component({
  selector: 'web-users',
  templateUrl: './users.component.html'
})
export class UsersComponent {

  public _usersList: User[];
  public _selectedUser: User;
  public _userToCreate: User;

  public user: CurrentUser;


  displayedColumns: string[] = [
    'id', 'username', 'editPermissions', 'visibilityPermissions', 'actionEdit', 'actionDelete'];



  fruitCtrl = new FormControl();
  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER]; //, COMMA // Alex  letter ת was filtered

  public _autocompleteCompaniesFilter: Observable<string[]>;

  public _autocompleteCompanies: string[];

  @ViewChild('fruitInput', { static: false }) fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto', { static: false }) matAutocomplete: MatAutocomplete;

  constructor(
    
    public _language: LanguageService,
    public _GuestsService: GuestsService,
    public _AuthService: AuthServiceGuest,
    public _dialog: MatDialog) {


    this._autocompleteCompaniesFilter = this.fruitCtrl.valueChanges.pipe(
      //startWith(null),
      map((fruit: string | null) => fruit ? this._filter(fruit) : this._autocompleteCompanies.slice()));



  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this._autocompleteCompanies.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }


  ngOnInit(): void {
    const self = this;

    self.user = self._AuthService.getUserInfo();

    self._GuestsService.selectedCompanySubject.subscribe(
      data => {
        if (data) {
          self.getUsers();

          self._autocompleteCompanies = [];

          for (let comp of self._GuestsService._companiesList) {
            self._autocompleteCompanies.push(comp.name);
          }
        
        }
      }
    );

    if (self._GuestsService._selectedCompany) {

      self.getUsers();

      self._autocompleteCompanies = [];

      for (let comp of self._GuestsService._companiesList) {
        self._autocompleteCompanies.push(comp.name);
      }
    }

    
  }

  onUserSelected(user: User) {

    const self = this;

    self._selectedUser = user;

    self.loadSelectedUserCompanies();
  }

  getUsers() {

    const self = this;

    self._GuestsService.getUsers()
      .subscribe((data: User[]) => {

        self._usersList = data;

        if (self._usersList.length > 0) {
          self._selectedUser = self._usersList[0];
          self.loadSelectedUserCompanies();
        }
      },
        error => { }
      );
  }


  applyFilter(event: Event) {

    const filterValue = (event.target as HTMLInputElement).value;

    console.log(`Users applyFilter ${filterValue}`);

    if (filterValue.length === 0) {

      this.getUsers();
    }
    else {
      this._usersList =
        this._usersList.filter(
          ttt => ttt.username.toLowerCase().includes(filterValue.toLowerCase()));
    }
  }

 
  companySelected(event: MatAutocompleteSelectedEvent): void {

    const self = this;


    if (!this._selectedUser.companiesList) {
      this._selectedUser.companiesList = [];
    }

    let company = self._GuestsService._companiesList.find(x => x.name === event.option.viewValue);

    self._GuestsService.addCompanyToUser(company, self._selectedUser.id)
      .subscribe((data: boolean) => {

        self.loadSelectedUserCompanies();
        
      },
        error => { }
      );

      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }

  remove(companyName: Company): void {

    const self = this;

    let company = self._GuestsService._companiesList.find(x => x.name === companyName.name);

    self._GuestsService.deleteCompanyFromUser(company, self._selectedUser.id)
      .subscribe((data: boolean) => {

        self.loadSelectedUserCompanies();

      },
        error => { }
      );
    
  }

  loadSelectedUserCompanies() {

    const self = this;

    self._GuestsService.getCompanies(self._selectedUser.id.toString())
      .subscribe((data: Company[]) => {

        self._selectedUser.companiesList = data;
      },
        error => { }
      );
  }

  public add(event: Event): Company[] {
    try {
      const filterValue = (event.target as HTMLInputElement).value;
      console.log(`Users add Company? ${filterValue}`);

      return this._GuestsService._companiesList.filter(x => x.name.toLowerCase().indexOf(filterValue) === 0);
    } catch (e) {
      console.log(e);
    }

  }


  onEditUserClick(id: number) {

    let self = this;

    var selectedUser = this._usersList.filter(x => x.id === id)[0];

    if (selectedUser) {

      const dialogRef = this._dialog.open(EditUserDialog, {
        width: '600px', height: '800px', direction: 'rtl', data: { selectedUser }

      });

      dialogRef.afterClosed().subscribe((dialogResult: User) => {

        if (dialogResult) {

          this._GuestsService.editUser(dialogResult)
                    .subscribe((result: ControllerResponse) => {

                            if (result.error == false) { self.getUsers(); }

                            if (result.error == true) {

                                  const dialogRef = this._dialog.open(MessageToUserDialog, {
                                    width: '200', height: '300', direction: 'rtl', data: { message: result.errorMessage, isMobile: 0 } //  result.errorMessage
                                  });

                                  dialogRef.afterClosed().subscribe((result: boolean) => {
                                  });

                                  self.getUsers();
                          }

                       },
                      error => { }
                    );
        }// if dialogResult


      });
    }
  }
  


  onDeleteUserClick(id: number) {

    let self = this;
    const dialogRef = this._dialog.open(MessageToUserDialog, {
      width: '200', height: '300', direction: 'rtl', data: { message:'AreYouSureDeleteUser', isMobile: 0 }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
     

      if (result === true) {

        this._GuestsService.deleteUser(id)
          .subscribe((result: ControllerResponse) => {

                  if (result.error == false) { self.getUsers(); }
                  else {
                    const dialogRef = this._dialog.open(MessageToUserDialog, {
                      width: '200', height: '300', direction: 'rtl', data: { message: result.errorMessage, isMobile: 0}
                      });

                      dialogRef.afterClosed().subscribe((result: boolean) => {
                      });

                      self.getUsers();
                  }
            },
            (error: any) =>
            {
              console.error(error);
            });
      }

    });
  }


  openNewUserDialog(): void {

    let self = this;

    let selectedUser = new User();

    const dialogRef = this._dialog.open(EditUserDialog, {
      width: '600px', height: '800px', direction: 'rtl', data: { selectedUser }

    });

    dialogRef.afterClosed().subscribe((result: User) => {
     
      if (result) {
         
        let _userToCreate = new NewUserModel();
        _userToCreate.usename = result.username;
        _userToCreate.password = result.password;
        _userToCreate.visibilityPermissions = result.visibilityPermissions;
        _userToCreate.editPermissions = result.editPermissions; // Alex added

        self.onNewUserSave(_userToCreate);
      }
    });
  }

  onNewUserSave(_userToCreate: NewUserModel) {

    let self = this;

    this._GuestsService.addUser(_userToCreate)
      .subscribe(
        (result: ControllerResponse) => {
          if (result.error == false) { self.getUsers() }
          if (result.error == true) {

            const dialogRef = this._dialog.open(MessageToUserDialog, {
              width: '200', height: '300', direction: 'rtl', data: { message: result.errorMessage, isMobile: 0 } //result.errorMessage
            });

            dialogRef.afterClosed().subscribe((result: boolean) => {
              console.log('Users onNewUserSave Dialog was closed');
            });

            self.getUsers()
          }
        },
       (error: any) => { console.log(error); },
       () => console.log('created new label set'));
  }

       
}
